import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useSaveDocument } from "../../../../hooks/panelEditor/useSaveDocument";
import { useGetStates } from "../../../../hooks/useGetStates";

export const SaveDocumentModal = ({ isOpen, onClose, token, onSuccess }) => {
  const { saveDocument, loading, error } = useSaveDocument(token);
  const { states, isLoadingStates } = useGetStates();

  const [formData, setFormData] = useState({
    name_document: "",
    id_type_document: "",
    id_plantilla: "",
    id_estado: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await saveDocument(formData);
    if (result.success) {
      if (onSuccess) onSuccess(result.data);
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onClose={!loading ? onClose : undefined} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600 }}>Crear Nuevo Documento</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Nombre del Documento"
            name="name_document"
            value={formData.name_document}
            onChange={handleChange}
            fullWidth
            required
            disabled={loading}
          />

          <TextField
            select
            label="Tipo de Documento"
            name="id_type_document"
            value={formData.id_type_document}
            onChange={handleChange}
            fullWidth
            required
            disabled={loading}
          >
            <MenuItem value={1}>Selecta</MenuItem>
            <MenuItem value={2}>Informa</MenuItem>
          </TextField>

          <TextField
            select
            label="Plantilla"
            name="id_plantilla"
            value={formData.id_plantilla}
            onChange={handleChange}
            fullWidth
            required
            disabled={loading}
          >
            <MenuItem value={1}>Selecta Lotenal</MenuItem>
            <MenuItem value={2}>Selecta AMDA</MenuItem>
          </TextField>

          <TextField
            select
            label="Estado"
            name="id_estado"
            value={formData.id_estado}
            onChange={handleChange}
            fullWidth
            required
            disabled={loading || isLoadingStates}
          >
            {states && states.length > 0 ? (
              states.map((state) => (
                <MenuItem key={state.id} value={state.id}>
                  {state.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                Cargando estados...
              </MenuItem>
            )}
          </TextField>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={onClose} disabled={loading} color="inherit">
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading || !formData.name_document}
            startIcon={loading ? <CircularProgress size={20} /> : null}
            disableElevation
          >
            Crear Documento
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
